import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import useBuildUpdateGlobalPaymentsRowsRows from './buildUpdateGlobalPaymentsRows.helper';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateGlobalPaymentsProps = {
  onSubmit: (params: vp.SetGlobalPayCredentialsRequest) => void;
  defaultValues: vp.SetGlobalPayCredentialsRequest;
};
type FC = FunctionComponent<UpdateGlobalPaymentsProps>;

const UpdateGlobalPayments: FC = (props: UpdateGlobalPaymentsProps) => {
  const history = useHistory();
  const { onSubmit, defaultValues } = props;
  const updateGlobalPaymentsRows = useBuildUpdateGlobalPaymentsRowsRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.GlobalPayments.Form' });
  const { t: tInt } = useTranslation('translations', { keyPrefix: 'Integrations' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={onSubmit}
      validationSchema={createdValidationSchema()}
      validateOnChange
      validateOnBlur
    >
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => {
        const updateGlobalPaymentsTable: vp.TableProps = {
          name: 'update-Global-Payments-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updateGlobalPaymentsRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="standard"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values[id]}
                error={errors[id] && touched[id] ? errors[id] : null}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box flx="col" mb="md" gapSize="16px">
              <UtilButton
                iconLeft="chevron_left"
                size="large"
                onClick={() => {
                  if (history.length > 1) {
                    history.goBack();
                  } else {
                    history.replace('/integrations');
                  }
                }}
              >
                {history.length > 1 ? tGlobal('Buttons.back') : tInt('pageTitle')}
              </UtilButton>
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updateGlobalPaymentsTable} />
            <Box mt="md" jc="fe">
              <Button id="Global-Payments-review" type="submit" label={tGlobal('Buttons.review')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
  function createdValidationSchema() {
    return Yup.object().shape({
      GlobalPayAppID: Yup.string()
        .label(t('globalPayAppID'))
        .required()
        .matches(/^.*\S+.*/, t('whiteSpaceValidation')),
      GlobalPaySharedSecret: Yup.string()
        .label(t('globalPaySharedSecret'))
        .required()
        .matches(/^.*\S+.*/, t('whiteSpaceValidation')),
    });
  }
};

export default UpdateGlobalPayments;
